import React, { useState } from 'react';
import { AuthProvider, useAuth } from './store/AuthContext';
import { ToastProvider } from './store/ToastContext';
import { Sidebar } from './components/Sidebar';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { TripsPage } from './pages/TripsPage';
import { DriversPage } from './pages/DriversPage';
import { VehiclesPage } from './pages/VehiclesPage';
import { HOSDashboard } from './pages/HOSDashboard';
import { FleetAnalytics } from './pages/FleetAnalytics';
import { FuelPage } from './pages/FuelPage';
import { UsersPage } from './pages/UsersPage';
import { LoadingSpinner } from './components/ui/LoadingSpinner';

function AppContent() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const [page, setPage] = useState('dashboard');

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-500 text-sm">Loading TruckManager…</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return <Login />;

  // Redirect drivers to their trips view
  const effectivePage = (user?.role === 'driver' && page === 'dashboard') ? 'trips' : page;

  const pages = {
    dashboard: <Dashboard onNavigate={setPage} />,
    trips:     <TripsPage />,
    drivers:   <DriversPage />,
    vehicles:  <VehiclesPage />,
    hos:       <HOSDashboard />,
    analytics: <FleetAnalytics />,
    fuel:      <FuelPage />,
    users:     <UsersPage />,
  };

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar page={effectivePage} onNavigate={setPage} />
      <main className="flex-1 flex flex-col overflow-hidden">
        {pages[effectivePage] || pages.dashboard}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </AuthProvider>
  );
}
